<div class="nim__content">
  <div class="nim__content-area relative width100">
    <div class="container flex justify-content-center">
      <div class="card__patient mt6 mb3 p4 med-order-matching-items-table-width">
        <div class="center mb2">
        <svg class="height-5 width-5 fill-warning-dark">
          <use xlink:href="assets/icons/connect-icons.svg#Warning"></use>
        </svg>
        </div>
        <h1 class="h3 bold center gray-40">Restart Required</h1>
        <div>
        <h1 class="h4 gray-40 center mt1">We were unable to load your practice's information, please wait while we try to restart Nucleus.</h1>
        <h1 class="h6 center gray-40 mt2">If after restarting Nucleus has not reconnected and you are still seeing this alert, please call the number below.</h1>
        <div class="flex justify-content-center my3">
          <button class="btn btn--true-blue h4" id="tryAgainButton" (click)="tryAgain()">Restart Nucleus</button>
        </div>
        <h1 class="h5 bold center gray-40 mt1">1.877.224.9692</h1>
        </div>
      </div>
    </div>
  </div>
</div>
